module.exports = __webpack_public_path__ + "public/1.0.1_626420/img/DA连快速烤箱连收板机.70f1d851.jpg";